import { useGetPrivateConstants } from 'api';
import countries from 'i18n-iso-countries';
import { useTranslation } from 'locales';
import { useLoadCommunicationLocales } from 'modules/Settings/Configuration/api';
import { useEffect } from 'react';
import { isDefined, isPlainObject } from 'remeda';
import { appActions } from 'store/app/app.actions';

import { useProfile } from '../../init/use-enforce-profile';

export function useLoadPrivateConstants() {
  const { communicationLanguages } = useLoadCommunicationLocales();
  const { currentLang } = useTranslation();
  const profile = useProfile();

  const {
    data: constantsRes,
    isLoading: isLoadingPrivateConstants,
    error: privateConstantsError,
  } = useGetPrivateConstants(
    {
      locale: profile?.locale,
    },
    { query: { enabled: isDefined(profile?.locale) } },
  );

  useEffect(() => {
    if (isPlainObject(constantsRes)) {
      const constantsWithLocalisedLists = {
        ...constantsRes,
        available_languages: communicationLanguages,
        countries: Object.entries(countries.getNames(currentLang)).map(([value, description]) => ({
          value,
          description,
        })),
      };
      appActions.constantsRes(
        constantsWithLocalisedLists,
        'fulfilled',
        constantsWithLocalisedLists,
      );
    }
  }, [constantsRes, communicationLanguages, currentLang]);

  return {
    privateConstants: constantsRes,
    isLoadingPrivateConstants,
    privateConstantsError,
  };
}
